import React from 'react';
import { Button, Dialog, DialogTitle, Box } from '@mui/material';
import EyeIcon from '@mui/icons-material/Visibility';

export default class ImagePreviewModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false
    };

    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  handleOpen() {
    this.setState({open: true});
  }

  handleClose() {
    this.setState({open: false});
  }

  render() {
    const { title, buttonLabel, image } = this.props;
    const { open } = this.state;

    return (
      <React.Fragment>
        <Button variant="outlined" onClick={this.handleOpen} style={{marginTop: '10px'}} startIcon={<EyeIcon />}>{buttonLabel}</Button>
        <Dialog open={open} onClose={this.handleClose} aria-label={title}>
          <DialogTitle>{title}</DialogTitle>
          <Box style={{padding: '20px'}}>
            <img src={image} style={{maxWidth: '100%'}} />

            <div className="button-container" style={{marginTop: '2em', textAlign: 'center'}}>
              <Button variant="contained" onClick={this.handleClose}>OK</Button>
            </div>
          </Box>
        </Dialog>
      </React.Fragment>
    );
  }
}
